var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"content-class":"domain-authenticate-modal","title":_vm.$t('message.email.message.authenticateDomain'),"max-width":_vm.maxWidth,"value":_vm.showing},on:{"input":_vm.emitShowing}},[(_vm.showing)?_c('domain-authenticate-form',{on:{"step":_vm.setModalMaxWidth,"validated":_vm.onValidated}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }